import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Button, FormControl, Grid } from "@mui/material";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import PinInput from "react-pin-input";
import { useState, useEffect } from "react";
import Loader from "../component/loading-screen/Loader";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import TimerButton from "../component/TimerButton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  height: "max-content",
  overflowY: "scroll",
  p: 2,
};

const AepsValidateComponent = ({
  
  verifStepSuccRes,
  currentStep = 3,
  setCurrentStep,

  
  handleCloseCallBk,
  showLaoder = true,
  setRequest,
  refreshUser,

  
  open = false,
  setOpen,

  
  title = "Verify OTP for AEPS",
  btn = "Verify",
  setStatusModalOpen,
  onSuccess,
  onClose,
  setStatusReferenceId,

  // For resend OTP
  data = null,
}) => {
  const [otp, setOtp] = useState("");
  const [err, setErr] = useState("");
  const [isresend, setIsResend] = useState(false);
  const [request, setLocalRequest] = useState(false);

  // Use parent's setRequest if provided, otherwise use local
  const requestSetter = setRequest || setLocalRequest;

  useEffect(() => {
    if (open) {
      setOtp("");
      setErr("");
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    setOtp("");
    setErr("");
    if (setOpen) {
      setOpen(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!otp || otp.length < 6) {
      setErr("Six Digit OTP Required");
      return;
    }

    const requestData = {
      otp,
      hash2: verifStepSuccRes?.hash,
      otpReferenceID: verifStepSuccRes?.otpReferenceID,
    };

    postJsonData(
      ApiEndpoints.AEPS_VALIDATE,
      requestData,
      requestSetter,
      (res) => {
        if (refreshUser) refreshUser();
        okSuccessToast(res.data.message);
        // setStatusModalOpen(true);
        handleClose();

        if (setCurrentStep) {
          setCurrentStep(currentStep + 1);
        }

        if (handleCloseCallBk) {
          handleCloseCallBk("closemodal");
        }
        if (onSuccess) {
          onSuccess(res.data);
        }
      },
      (err) => {
        apiErrorToast(err);
        setErr(err.response?.data?.message || "Verification failed");
      }
    );
  };

  const resendOtpFunc = () => {
    if (!data) {
      apiErrorToast("No data available for resend");
      return;
    }

    postJsonData(
      ApiEndpoints.SIGN_UP_LAST,
      data,
      requestSetter,
      (res) => {
        okSuccessToast(res.data.message);
        setIsResend(true);
      },
      (err) => {
        apiErrorToast(err);
        setIsResend(false);
      }
    );
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} className="sm_modal">
        <Loader loading={request} />
        <ModalHeader title={title} handleClose={handleClose} />

        <Box
          component="form"
          id="AepsValidateForm"
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit}
          sx={{
            "& .MuiTextField-root": { m: 2 },
          }}
        >
          <Grid container sx={{ pt: 1 }}>
            <Grid
              item
              md={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <FormControl>
                <PinInput
                  length={6}
                  focus
                  type="password"
                  onChange={(value) => {
                    if (err) {
                      setErr("");
                    }
                    setOtp(value);
                  }}
                  regexCriteria={/^[0-9]*$/}
                  style={{ padding: "10px" }}
                />
              </FormControl>
            </Grid>

            {err && (
              <Grid item xs={12} sx={{ textAlign: "center", mt: 2 }}>
                <Box sx={{ color: "#DC5F5F", fontSize: "14px" }}>{err}</Box>
              </Grid>
            )}
          </Grid>

          <Grid
            item
            md={12}
            xs={12}
            sx={{ display: "flex", justifyContent: "end", pr: 11, mt: 2 }}
          >
            <Box>
              {isresend ? (
                <TimerButton
                  initialSeconds={30}
                  setIsResend={setIsResend}
                  isresend={isresend}
                />
              ) : (
                <Button
                  onClick={resendOtpFunc}
                  disabled={!data}
                  sx={{
                    position: "relative",
                    textTransform: "none",
                  }}
                >
                  <Loader loading={request && showLaoder} size="small" />
                  Resend OTP
                </Button>
              )}
            </Box>
          </Grid>
        </Box>

        <ModalFooter form="AepsValidateForm" btn={btn} />
      </Box>
    </Modal>
  );
};

export default AepsValidateComponent;
